import { FormControlProvider } from 'contexts/FormControlContext'
import Client from './Client'
import Members from './Members'
import Notes from './Notes'
import { Checklists } from './Checklists/'

export default function Details() {
  return (
    // CLIENT, MEMBERS, NOTES, CHECKLISTS, ACTIVITY LOG
    <>
      <Client />

      <Members />

      <FormControlProvider>
        <Notes />
      </FormControlProvider>

      <Checklists />
    </>
  )
}